// src/utils/validation.ts
export const normalizeEmail = (email: string): string => {
    return email.trim().toLowerCase();
};

export const validateEmail = (email: string): boolean => {
    if (!email) return false;
    const trimmed = email.trim();
    const emailRegex = /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/;
    return emailRegex.test(trimmed);
};

export const getEmailError = (email: string): string => {
    if (!email) return 'Email обязателен';
    if (!validateEmail(email)) return 'Введите корректный email';
    return '';
};

export const validatePassword = (password: string): { isValid: boolean; error?: string } => {
    if (!password) {
        return { isValid: false, error: 'Введите пароль' };
    }
    if (password.length < 6) {
        return { isValid: false, error: 'Пароль должен содержать минимум 6 символов' };
    }
    return { isValid: true };
};

export const validateRequired = (value: string, fieldName: string): { isValid: boolean; error?: string } => {
    if (!value || !value.trim()) {
        return { isValid: false, error: `${fieldName} обязательно для заполнения` };
    }
    return { isValid: true };
};

export const getRequiredError = (value: string, fieldName: string): string => {
    return validateRequired(value, fieldName).error || '';
};

// 👇 ДОБАВИТЬ ЭТУ ФУНКЦИЮ
export const normalizePhone = (phone: string): string => {
    return phone.replace(/[^0-9]/g, '');
};